import React, { useEffect, useImperativeHandle, useState } from "react";
import { Modal, Space, Row, Col, Button, Form, Input, Typography, Divider, Descriptions, List, Table, Radio, Checkbox, Select } from "antd";
import "./LessCondition.scss";
import Icons from "assets/icons";


const LessCondition = React.forwardRef((props: any, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

	const [form] = Form.useForm();
	const colums = [
		{
			title: <Typography.Text strong>Nội dung</Typography.Text>,
			dataIndex: 'noiDung',
			key: 'noiDung',
		},
		{
			title: <Typography.Text strong>Cách tính điểm</Typography.Text>,
			dataIndex: 'noiDung',
			key: 'noiDung',
		},
		{
			title: <Typography.Text strong>Cách tính điểm</Typography.Text>,
			dataIndex: 'noiDung',
			key: 'noiDung',
		},
	]
  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
		getValue: form.getFieldValue,
		getValues: form.getFieldsValue,
		setValue: form.setFieldValue,
		setValues: form.setFieldsValue,
    resetFields: form.resetFields
  }));
	const onFinish = async (values) => {

	}
	const handleOnClick = async () => {
    await props.onSave(1);
    closeModal();
	}
  useEffect(() => {});
  useEffect(() => {}, [isModalOpen]);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
				title={"Lý do"}
				width={960}
			>
        <Row>
          <Row>
						<Form form={form} onFinish={onFinish}>
							<Row gutter={[4, 8]}>
								<Col xs={24} sm={24} md={24} lg={24} xl={24}>
									<Form.Item
										label={<Typography.Text ellipsis>Lý do</Typography.Text>}
										name="lyDoKhongDuDieuKienPhauThuat"
										labelAlign="left"
										labelCol={{span: 2}}
										wrapperCol={{span: 22}}
									>
										<Input 
											className='data-input-field'
											placeholder='Nhập'
										/>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</Row>
					<Row justify={'end'} style={{gap: '4px', marginTop: '4px'}}>
						<Button type='primary' icon={<Icons.close />} danger onClick={closeModal}>Hủy</Button>
						<Button type='primary' icon={<Icons.save />} onClick={handleOnClick}>Lưu</Button>
					</Row>
        </Row>
      </Modal>
    </div>
  );
});

export default LessCondition;
